<era-pane>
  <era-reboot-devices-modal-ui [locationSubset]="locationSubset"
                               (closeModal)="closeModal()"
                               (submitFilters)="rebootDevices($event)">
  </era-reboot-devices-modal-ui>
</era-pane>